import SendEmail from "../../components/SendEmail";
import { Footer } from "../../components";

const Contact = () => {
  document.title = "Contact | Nguyen Phuc Tien";
  return (
    <article className="contact-main">
      <h2 className="title-font pink-text h2-tag">Contact Me</h2>
      <br></br>
      <p className="white-text p-tag">
      If you are interested in hiring me or have any other requests or questions regarding embedded software development, 
      feel free to reach out. I am always open to new opportunities and interesting projects
      </p>
      <SendEmail />
      <Footer />
    </article>
  );
};

export default Contact;
